import React from "react";
import {
  Box,
  Text,
  VStack,
  Link,
  Image,
  useBreakpointValue,
} from "@chakra-ui/react";
import badge from "../../../assets/home/badge.png"; // update path as needed

const HowToApply = () => {
  const imageSize = useBreakpointValue({ base: "60px", md: "80px", lg: "100px" });

  return (
    <Box w="100%" display="flex" justifyContent="center" py={6} bg="#F5F5F5">
      <Box
        bg="#005770"
        w={{ base: "90%", md: "85%", lg: "80%" }}
        py={{ base: 12, md: 8 }}
        position="relative"
        textAlign="center"
        borderRadius="md"
      >
        {/* Top Circular Badge */}
        <Box position="absolute" top="-30px" left="30%" transform="translateX(-50%)">
          <Image src={badge} alt="Badge" boxSize={imageSize} data-animated = 'true'  className="fade-in-up"/>
        </Box>

        <VStack spacing={4} maxW="90%" mx="auto" mt="40px">
          <Text
            fontSize={{ base: "lg", md: "2xl" }}
            fontWeight="bold"
            color="white"
            fontStyle="italic"
            className="fade-in-up"
          >
            How To <Text as="span" color="#D9A25F" className="fade-in-up">Apply</Text>
          </Text>
          <Text fontSize={{ base: "sm", md: "md" }} color="white" className="fade-in-up">
            Send your resume and portfolio to{" "}
            <Link
              href="mailto:info@doggleindia.com"
              color="white"
              textDecoration="underline"
              fontWeight="semibold"
            >
              info@doggleindia.com
            </Link>{" "}
            Let’s create digital wonders together!
          </Text>
        </VStack>
      </Box>
    </Box>
  );
};

export default HowToApply;
